<template>
  <div class="w-50pct">
    <v-date-picker
      v-model="range"
      mode="date"
      :masks="masks"
      is-range
      color="green"
      :is-dark="$store.state.darkMode"
      class="v-date-picker"
      :columns="$screens({ default: 1, lg: 2 })" 
    >
      <template v-slot="{ inputValue, inputEvents, isDragging }">
        <div class="flex flex-col sm:flex-row justify-start items-center">
          <div class="relative flex-grow inline mr-1 w-48pct">
            <svg
              class="pointer-events-none calendaricon"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              ></path>
            </svg>
            <input
              class="
                flex-grow
                pl-4
                pr-0
                py-1
            
             
               
                form-control
                reportrange-text
              "
              :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
              :value="inputValue.start"
              v-on="inputEvents.start"
            />
          </div>
          <!-- <span class="flex-shrink-0 m-2">
            <svg
              class="w-4 h-4 stroke-current text-gray-600"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </span> -->
          <div class="relative flex-grow inline w-49pct">
            <svg
              class="pointer-events-none calendaricon"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              ></path>
            </svg>
            <input
              class="
                flex-grow
                pl-4
                pr-0
                py-1
                border
                w-full
                form-control
                reportrange-text
              "
              :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
              :value="inputValue.end"
              v-on="inputEvents.end"
            />
          </div>
        </div>
      </template>
    </v-date-picker>
    <!-- {{ value }} -->
    <!-- <v-date-picker v-model="value" is-range>
      <template v-slot="{ inputValue, inputEvents }">
        <div class="flex justify-center items-center">
          <input
            :value="inputValue.start"
            v-on="inputEvents.start"
            class="
              border
              px-2
              py-1
              w-32
              rounded
              focus:outline-none focus:border-indigo-300
            "
          />
          <svg
            class="w-4 h-4 mx-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            />
          </svg>
          <input
            :value="inputValue.end"
            v-on="inputEvents.end"
            class="
              border
              px-2
              py-1
              w-32
              rounded
              focus:outline-none focus:border-indigo-300
            "
          />
        </div>
      </template>
    </v-date-picker> -->
    <!-- <v-date-picker
      v-model="value"
      mode="date"
      :masks="masks"
      is-range
      color="green"
      :is-dark="$store.state.darkMode"
      class="v-date-picker"
    >
      <template v-slot="{ inputValue, inputEvents, isDragging }">
        <div class="flex flex-col sm:flex-row justify-start items-center">
          <div class="relative flex-grow">
            <svg
              class="pointer-events-none calendaricon"
              fill="none"
              stroke-linecap="rec"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              ></path>
            </svg>
            <input
              class="
                flex-grow
                pl-4
                pr-0
                py-1
                border
                w-full
                form-control
                reportrange-text
              "
              :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
              :value="inputValue.start + ' - ' + inputValue.end"
              v-on="inputEvents.start"
            />
          </div>
    
          <span class="flex-shrink-0 m-2">
            <svg
              class="w-4 h-4 stroke-current text-gray-600"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </span>
      
        </div>
      </template></v-date-picker
    > -->
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object, required: true },
  },
  data() {
    return {
      // message: "",
      range: {
        start: new Date(2022, 11, 6),
        end: new Date(2022, 11, 23),
      },
      masks: {
        input: "DD/MM/YY",
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      async handler(newVal, oldVal) {
        console.log(newVal);
        this.$emit("input", newVal);
      },
    },
  },
};
</script>

<style>
.v-date-picker svg.calendaricon {
  position: absolute;
  width: 16px;
  top: 6px;
  left: 5px;
}
</style>